import React, { Component } from "react";
import TextField from "material-ui/TextField";
import * as Colors from "../../utils/Color";
import { Field } from "react-form";
import { validate } from "../../utils/validation";
import { connect } from "react-redux";

const styles = {
  errorStyle: {
    color: Colors.error
  },
  underlineStyle: {
    borderColor: Colors.grey
  },
  underlineFocusStyle: {
    borderColor: Colors.primary
  },
  floatingLabelStyle: {
    fontWeight: "bold",
    color: Colors.grey50
  },
  hintLabelStyle: {
    fontWeight: "bold",
    color: Colors.grey50
  },
  floatingLabelFocusStyle: {
    color: Colors.grey50,
    fontSize: "18px"
  }
};

class TextFields extends Component {
  state = {
    value: "",
    touched: false
  };

  componentDidMount() {
    if (
      (this.props.defaultValue || this.props.defaultValue === 0) &&
      this.props.formApi &&
      !this.props.mobile
    ) {
      this.props.formApi.setValue(this.props.field, this.props.defaultValue);
      this.setState({ value: this.props.defaultValue });
    }

    if (this.props.mobile) {
      this.setState({ value: this.props.defaultValue });
    }
  }

  onBlurHandler = (setValue, setTouched) => {
    if (!this.state.touched) {
      setValue(this.state.value);
      setTouched();
      this.setState({ touched: true });
    }
  };

  onChangeHandler = (e, setValue) => {
    if (this.props.mobile && e.target.value.length < 5) {
      return;
    }

    if (this.state.touched) {
      setValue(e.target.value);
      this.setState({ value: e.target.value });
    } else {
      this.setState({ value: e.target.value });
    }
  };

  render() {
    const { validations } = this.props;
    let floatingLabelStyle;
    let inputStyle = {};
    if (this.props.heightSize) {
      inputStyle.marginTop = "10px";
      floatingLabelStyle = { ...styles.floatingLabelStyle, top: "25px" };
    }
    if (this.props.arb) {
      inputStyle.direction = "rtl";
    }

    return (
      <Field
        validate={value => validate(value, validations)}
        field={this.props.field}
      >
        {fieldApi => {
          const { setValue, setTouched, error } = fieldApi;
          return (
            <TextField
              value={this.state.value}
              id={this.props.id}
              multiline="true"
              name={this.props.name}
              inputStyle={inputStyle}
              style={
                this.props.hide
                  ? { display: "none" }
                  : this.props.heightSize
                    ? { height: this.props.heightSize }
                    : null
              }
              disabled={this.props.disabled}
              hintText={this.props.hintText}
              hintStyle={styles.hintLabelStyle}
              onBlur={e => this.onBlurHandler(setValue, setTouched)}
              onChange={e => this.onChangeHandler(e, setValue)}
              errorText={
                this.props.error && this.props.error[this.props.field]
                  ? this.props.error[this.props.field]
                  : error
              }
              type={this.props.type}
              fullWidth={true}
              className="text-field"
              floatingLabelText={this.props.label}
              underlineStyle={styles.underlineStyle}
              underlineFocusStyle={styles.underlineFocusStyle}
              floatingLabelStyle={
                this.props.heightSize
                  ? floatingLabelStyle
                  : styles.floatingLabelStyle
              }
              floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
              floatingLabelFixed={this.props.floatingLabelFixed}
            />
          );
        }}
      </Field>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.auth.error
  };
};

export default connect(mapStateToProps)(TextFields);



// WEBPACK FOOTER //
// ./src/components/UI/TextFiled.js